import useSWRImmutable from 'swr/immutable'

import { useApis } from '../contexts/api-context'
import { type ApisType } from '../store/createApis'
import { type ReviewType } from '../types/TherapistStateType'
import useTherapist from './useTherapist'

const fetchReviews = async (api: ApisType['api'], therapistUserId?: number): Promise<ReviewType[]> => {
  if (!therapistUserId) {
    return []
  }
  const res = await api.getReviews(therapistUserId)
  return res.data
}

const useReviews = (therapistId: number) => {
  const { therapist } = useTherapist(therapistId)
  const { api } = useApis()
  const { data, isLoading, mutate } = useSWRImmutable(['useReviews', therapist?.therapistUserId], () =>
    fetchReviews(api, therapist?.therapistUserId),
  )
  const countOfPositiveTextReviews = data?.filter((review) => review.text).length || 0
  return { reviews: data, countOfPositiveTextReviews, isLoading, refetchReviews: mutate }
}

export default useReviews
